import Component from '../../lib/component'

export default class SelectComponent extends Component {
    static selector () {
        return '.select'
    }

    constructor (opts) {
        super(opts)

        if (!this.el)
            return

        if (!this.getSelect()
                || this.getSelect().multiple)
            return

        if (!this.getFeature('touch'))
            this.render()

        this.listen()
    }

    listen () {
        if (!this.getSelect())
            return

        if (!this.getFeature('touch')) {
            if (!this.getSelectBtn()
                    || !this.getSelectOptionsList())
                return

            this.getSelectBtn().onclick = this.onBtnClick.bind(this)
            this.getSelectBtn().onkeydown = this.onBtnKeydown.bind(this)

            this.getSelectOptionsList().onkeydown = this.onListboxKeydown.bind(this)
            this.getSelectOptionsList().onclick = this.onListboxClick.bind(this)

            document
                .addEventListener('click', this.onDocumentClick.bind(this), false)

            document.body
                .addEventListener('keydown', (e) => {
                    if (!this.el.classList.contains('active'))
                        return

                    const key = (e.key || e.keyIdentifier || '')

                    if (this.getSelectBtn()
                            && (key.match(/tab/i)
                                || e.which === 27)) {
                        e.preventDefault()
                        e.stopPropagation()

                        this.getSelectBtn().click()
                    }
                })
        }

        if (!('MutationObserver' in window))
            return

        (new window
            .MutationObserver((mutations) => {
                if ((mutations || [{}])[0].type === 'attributes'
                        && (mutations || [{}])[0].target.tagName
                            .match(/option/i)
                        && (mutations || [{}])[0].attributeName === 'disabled')
                    return this.onOptionAttrChange((mutations || [{}])[0].target)

                if (this.getFeature('touch'))
                    return

                if ((mutations || [{}])[0].type === 'childList')
                    return this.renderOptionsList()

                if (this.getSelect().disabled
                        && !this.getSelectBtn().disabled)
                    return this.setSelectDisabled()

                if (!this.getSelect().disabled
                        && this.getSelectBtn().disabled)
                    this.setSelectEnabled()
            }))
            .observe(this.getSelect(), {
                attributes: true,
                childList: true,
                subtree: true
            })
    }

    onBtnClick (e = {}) {
        if (this.getSelect().disabled)
            return this.setSelectDisabled()

        this.setSelectEnabled()

        if (this.el.classList.contains('dirty')
                && this.getSelect().required
                && !this.getSelectOptionsList()
                    .getAttribute('aria-activedescendant'))
            this.el.classList.add('invalid')

        if (!this.el.classList.contains('dirty'))
            this.el.classList.add('dirty')

        this.el.classList.toggle('active')

        if (!this.el.classList.contains('active'))
            return

        this.getSelectOptionsList().focus()

        if ((e.keyIdentifier || e.key || '').match(/down/i))
            this.setSelectedOption()
    }

    onBtnKeydown (e) {
        const key = (e.key || e.keyIdentifier || '')

        if (!this.el.classList.contains('active')
                && (key.match(/(down|up)/i)
                    || key.match(/^(\d|\w)$/i)))
            return this.onListboxKeydown(e)

        if (!key.match(/enter/i)
                && !(key.match(/(down|up|\s)/i)
                    && !this.el.classList.contains('active')))
            return

        e.preventDefault()
        e.stopPropagation()

        this.onBtnClick(e)
    }

    onListboxClick (e) {
        this.setSelectedOption(e.target)
        this.el.classList.remove('active')
        return this.getSelectBtn().focus()
    }

    onListboxKeydown (e) {
        const key = (e.key || e.keyIdentifier || '')

        if (e.which === 27 || key.match(/enter/i)) {
            e.preventDefault()
            e.stopPropagation()

            this.el.classList.remove('active')
            return this.getSelectBtn().focus()
        }

        const items = this.getSelectOptionsListItems(false)

        if (!items.length)
            return

        const selectOption = (el) => {
            e.preventDefault()
            e.stopPropagation()

            this.setSelectedOption(el, key)
        }

        if (key.match(/(home|end)/i))
            return selectOption(
                key.match(/home/i)
                    ? items[0]
                    : items[items.length - 1])

        const selected = this.getSelectOptionsList()
            .querySelector('[aria-selected="true"][role=option]')

        const selectedIdx = items.indexOf(selected)

        if (key.match(/(up|down)/i)) {
            if (selectedIdx < 0)
                return

            const next = key.match(/down/i)
                ? items[selectedIdx + 1]
                : items[selectedIdx - 1]

            if (next)
                return selectOption(next)
        }

        if (!key.match(/(\d|\w)/))
            return

        const jumpTo = items.slice(selectedIdx + 1)
            .find(el => el.innerText.toLowerCase().charAt(0)
                === key.toLowerCase())

        if (jumpTo)
            selectOption(jumpTo)
    }

    onDocumentClick (e) {
        if (!this.getSelectContainer()
                || !this.getSelectBtn()
                || !this.el.classList.contains('active')
                || this.getSelectContainer().contains(e.target))
            return

        this.onBtnClick()
    }

    onOptionAttrChange (target) {
        if (!this.getFeature('touch'))
            this.renderOptionsList()

        if (this.getSelectedOption() !== target
                || !target.disabled)
            return

        const selectedIdx = target.nextElementSibling
                && !target.nextElementSibling.disabled
            ? this.getSelect().selectedIndex + 1
            : this.getSelectOptions()
                .map((el, idx) => !el.disabled
                    ? idx
                    : null)
                .filter(int => int >= 0)[0]

        if (selectedIdx >= 0 && !this.getFeature('touch'))
            this.setSelectedOption(
                this.getSelectOptionsList()[selectedIdx])

        if (!this.getFeature('touch'))
            return

        this.getSelect().selectedIndex = selectedIdx
        this.getSelect().value = this.getSelectOptions()[selectedIdx].value

        let evt

        try {
            evt = new window.Event('change', { view: window, bubbles: true })
        }
        catch (e) {
            evt = document.createEvent('Event')
            evt.initEvent('change', true, true)
        }

        this.getSelect().dispatchEvent(evt)
    }

    getSelectedOptionDefault () {
        return this.getSelectOptionsList()
            .querySelector('[aria-selected="true"]')
                || this.getSelectOptionsListItems()
                    .filter(el =>
                        el.getAttribute('aria-disabled') !== 'true')[0]
    }

    getSelect () {
        return this.el.querySelector('select')
    }

    getSelectBtn () {
        return this.el.querySelector('.select-btn')
    }

    getSelectContainer () {
        return this.el.querySelector('.select-container')
    }

    getSelectOptionsList () {
        return this.el.querySelector('.select-options')
    }

    getSelectedOption () {
        return this.getSelect().selectedIndex < 0
            ? null
            : this.getSelect()
                .querySelectorAll('option')[this.getSelect().selectedIndex]
    }

    getSelectOptions () {
        return Array.from(this.el.querySelectorAll('select option'))
    }

    getSelectOptionsListItems (enabledItems = true) {
        return Array
            .from(this.getSelectOptionsList()
                .querySelectorAll('[role="option"]'))
            .filter(el => enabledItems
                ? el.getAttribute('aria-disabled') !== 'true'
                : el)
    }

    setSelectedText (str, className) {
        const btnTextEl = this.getSelectBtn().querySelector('span')

        btnTextEl.innerText
            = (str || (this.getSelectedOptionDefault() || {}).innerText || '')
                .trim()

        className
            ? btnTextEl.setAttribute('class', className)
            : btnTextEl.removeAttribute('class')
    }

    setSelectedOption (el, key) {
        const listItems = this.getSelectOptionsListItems(false)

        if (!listItems.length)
            return

        el = el || this.getSelectedOptionDefault()

        const isOptionDisabled = el.getAttribute('aria-disabled') === 'true'

        if (!el
                || (isOptionDisabled && !key)
                || (isOptionDisabled
                    && !this.getSelectOptionsListItems().length))
            return

        if (isOptionDisabled) {
            const dir = key.match(/end|up/i)
                ? -1
                : 1

            const itemsCache = [el]

            let closestItem = null
            let idx = (listItems.indexOf(el) || 0) + dir

            while (!closestItem) {
                if (listItems[idx]
                        && listItems[idx]
                            .getAttribute('aria-disabled') !== 'true') {
                    closestItem = listItems[idx]
                    break
                }

                itemsCache.push(listItems[idx])

                if (itemsCache.length === listItems.length)
                    break

                idx = idx + dir
            }

            if (!closestItem)
                return

            el = closestItem
        }

        if (el.getAttribute('aria-selected') !== 'true')
            listItems
                .filter(node => node.getAttribute('aria-selected'))
                .forEach(node => node.removeAttribute('aria-selected'))

        const option = this.getSelect()
            .querySelector(`option[data-id="${el.id}"]`)

        if (!option)
            return this.getSelect().required
                ? this.el.classList.add('invalid')
                : null

        if (this.el.classList.contains('invalid'))
            this.el.classList.remove('invalid')

        el.setAttribute('aria-selected', true)

        this.getSelectOptionsList()
            .setAttribute('aria-activedescendant', el.id)

        this.getSelectOptionsList().scrollTop = el.offsetTop
        this.setSelectedText()

        if (option === this.getSelectedOption())
            return

        this.getSelect().selectedIndex = Array.from(this.getSelect()
            .querySelectorAll('option'))
            .indexOf(option)

        this.getSelect().value = option.value

        const evt = this.getBrowser('name') === 'ie'
            ? document.createEvent('Event')
            : new window.Event('change', { view: window, bubbles: true })

        if (this.getBrowser('name') === 'ie')
            evt.initEvent('change', true, true)

        this.getSelect().dispatchEvent(evt)
    }

    setSelectDisabled () {
        if (!this.getSelect() || !this.getSelectBtn())
            return

        if (this.el.classList.contains('active'))
            this.el.classList.remove('active')

        if (!this.getSelect().disabled)
            this.getSelect().disabled = true

        if (!this.getSelectBtn().disabled)
            this.getSelectBtn().disabled = true
    }

    setSelectEnabled () {
        if (!this.getSelect() || !this.getSelectBtn())
            return

        if (this.getSelect().disabled)
            this.getSelect().disabled = false

        if (this.getSelectBtn().disabled)
            this.getSelectBtn().disabled = false
    }

    renderAriaLabel (el, idx) {
        if (!el || !el.tagName.match(/label/i))
            return el

        el.id = el.id || `${this.getSelect().id}-label-${idx}`
        el.setAttribute('for', `${this.getSelect().id}-btn`)
        el.classList.add('select-label')
        el.addEventListener('click', () => this.getSelectBtn().focus())

        return el
    }

    renderOptionsList () {
        let optionsList = this.getSelectOptionsList()

        if (!optionsList) {
            optionsList = document.createElement('ul')
            optionsList.className = 'select-options unstyled'
            optionsList.id = `${this.getSelect().id}-listbox`
            optionsList.setAttribute('role', 'listbox')
            optionsList.setAttribute('tabindex', -1)

            this.getSelectContainer().appendChild(optionsList)
        }

        this.getSelectOptions()
            .forEach((option, idx) => {
                if (idx === 0
                        && option.selected
                        && !option.value)
                    this.setSelectedText(option.innerHTML, 'select-placeholder')

                const id = `${this.getSelect().id}-option-${idx}`
                option.setAttribute('data-id', id)

                const listboxOption = this.el.querySelector(`#${id}`)

                if (!listboxOption)
                    optionsList.innerHTML += `<li ${
                        option.selected ? 'aria-selected="true" ' : ''}${
                        option.disabled ? 'aria-disabled="true" ' : ''}value="${
                        option.value}" role="option" id="${id}"><span>${
                        option.innerHTML}</span></li>
                    `

                if (!listboxOption)
                    return

                listboxOption
                    .setAttribute('aria-selected',
                        option.selected && !option.disabled)

                listboxOption
                    .setAttribute('aria-disabled',
                        option.disabled)

                listboxOption
                    .setAttribute('value',
                        option.value)

                if (listboxOption.querySelector('span'))
                    listboxOption.querySelector('span')
                        .innerHTML = option.innerHTML
            })

        if (!this.getSelectBtn().innerText.length)
            this.setSelectedOption()
    }

    renderSelectBtn () {
        let selectBtn = this.getSelectBtn()

        if (!selectBtn) {
            selectBtn = document.createElement('button')
            selectBtn.innerHTML = '<span></span>'

            this.getSelectContainer()
                .appendChild(selectBtn)
        }

        selectBtn.id = `${this.getSelect().id}-btn`
        selectBtn.className = 'select-btn btn-unstyled'
        selectBtn.setAttribute('aria-haspopup', 'listbox')
        selectBtn.setAttribute('aria-labelledby', selectBtn.id)
    }

    render () {
        if (!this.getSelect())
            return

        const select = this.getSelect()

        select.id = select.id || `select-${this.generateGUID()}`
        select.setAttribute('aria-hidden', true)
        select.setAttribute('tabindex', -1)

        if (!this.getSelectContainer()) {
            const selectContainer = document.createElement('div')
            selectContainer.classList.add('select-container')
            this.el.appendChild(selectContainer)
        }

        if (!this.getSelectBtn() || !this.getSelectBtn().id)
            this.renderSelectBtn()

        if (!this.getSelectOptionsList())
            this.renderOptionsList()

        const labelledby = Array.from(this.el
            .querySelectorAll(`label[for="${this.getSelect().id}"]`))
            .map((el, idx) => this.renderAriaLabel(el, idx))
            .map(el => el.id)
            .filter(str => str)
            .concat((this.getSelect().getAttribute('aria-labelledby') || '')
                .split(/\s+/)
                .filter(str => str.length)
                .map(id => this.el.querySelector(`#${id}`))
                .filter(el => el))
            .join(' ')

        if (labelledby && this.getSelectOptionsList())
            this.getSelectOptionsList()
                .setAttribute('aria-labelledby', labelledby)

        if (labelledby && this.getSelectBtn())
            this.getSelectBtn()
                .setAttribute('aria-labelledby', (`${labelledby} ${
                    this.getSelectBtn()
                        .getAttribute('aria-labelledby')}`).trim())

        if (this.getSelect().disabled)
            this.setSelectDisabled()
    }
}
